import { render, staticRenderFns } from "./ApprovalSlaInsightOverview.vue?vue&type=template&id=4c8ca2c6&scoped=true"
import script from "./ApprovalSlaInsightOverview.vue?vue&type=script&lang=js"
export * from "./ApprovalSlaInsightOverview.vue?vue&type=script&lang=js"
import style0 from "./ApprovalSlaInsightOverview.vue?vue&type=style&index=0&id=4c8ca2c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ca2c6",
  null
  
)

export default component.exports